"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CalendarDateUtility_1 = __importDefault(require("./CalendarDateUtility"));
class CalendarWeekModelBuilder {
    build(inputCalModel) {
        const calModel = inputCalModel;
        if (!inputCalModel || !inputCalModel.days || !inputCalModel.configuration) {
            throw Error('Unknown calendar model');
        }
        const daysMap = this._getCalDaysMap(calModel.days);
        const weeklyCalStartDate = this._getWeeklyCalendarStartDate(CalendarDateUtility_1.default.getDateObject(calModel.days[0].date), calModel.configuration);
        const weeklyCalEndDate = this._getWeeklyCalendarEndDate(CalendarDateUtility_1.default.getDateObject(calModel.days[calModel.days.length - 1].date), calModel.configuration);
        calModel.weeks = this._getWeekModels(weeklyCalStartDate, weeklyCalEndDate, daysMap);
        return calModel;
    }
    _getCalDaysMap(calDays) {
        const calDaysMap = new Map();
        for (let dayIndex = 0; dayIndex < calDays.length; dayIndex++) {
            let calDay = calDays[dayIndex];
            // do not create new day record if already passed from backend
            if (calDay.slots.length > 0 || calDay.id) {
                calDaysMap[calDay.date] = calDay;
            }
        }
        return calDaysMap;
    }
    _getWeeklyCalendarStartDate(defaultStartDate, configuration) {
        let calendarStartDate;
        let calculatedDate;
        if (configuration.showWholeMonth) {
            calculatedDate = new Date(defaultStartDate.getFullYear(), defaultStartDate.getMonth(), 1);
        }
        else {
            calculatedDate = defaultStartDate;
        }
        var calculatedDateWeekDay = calculatedDate.getDay();
        var weekDayInCalendarLocale = CalendarDateUtility_1.default.getWeekDayInCalendarLocale(calculatedDateWeekDay, configuration.firstDayOfWeek);
        // if it's first day of week then it's calendar start date
        if (weekDayInCalendarLocale !== 0) {
            calculatedDate.setDate(calculatedDate.getDate() - weekDayInCalendarLocale);
        }
        calendarStartDate = calculatedDate;
        return calendarStartDate;
    }
    _getWeeklyCalendarEndDate(defaultEndDate, configuration) {
        let calendarEndDate;
        let calculatedDate;
        if (configuration.showWholeMonth) {
            calculatedDate = new Date(defaultEndDate.getFullYear(), defaultEndDate.getMonth(), CalendarDateUtility_1.default.getNumOfDaysInMonth(defaultEndDate));
        }
        else {
            calculatedDate = defaultEndDate;
        }
        const calculatedDateWeekDay = calculatedDate.getDay();
        const weekDayInCalendarLocale = CalendarDateUtility_1.default.getWeekDayInCalendarLocale(calculatedDateWeekDay, configuration.firstDayOfWeek);
        // if it's last day of week then it's calendar start date
        if (weekDayInCalendarLocale !== 6) {
            calculatedDate.setDate(calculatedDate.getDate() + (6 - weekDayInCalendarLocale));
        }
        calendarEndDate = calculatedDate;
        return calendarEndDate;
    }
    _getWeekModels(calStartDate, calEndDate, daysMap) {
        const weekModels = [];
        while (calStartDate.getTime() < calEndDate.getTime()) {
            const days = [];
            for (let index = 0; index < 7; index++) {
                const dateString = CalendarDateUtility_1.default.getDateString(calStartDate);
                if (daysMap[dateString]) {
                    days.push(daysMap[dateString]);
                }
                else {
                    days.push({
                        date: dateString,
                        slots: [],
                        id: dateString
                    });
                }
                calStartDate.setDate(calStartDate.getDate() + 1);
            }
            weekModels.push({ days: days });
        }
        return weekModels;
    }
}
exports.default = CalendarWeekModelBuilder;
